import axios from 'axios';
import { HANDLE_ERRORS, FILE_SAVED } from './types';
import BASE_URL from '../helpers/base-url';
import authorizeRequest from "../helpers/authorize-request";

export const saveToJSONFile = data => async (dispatch, getState) => {
  try {
    const postData = { asset: data };
    await axios.post(`${BASE_URL}/api/file/asset`, postData, authorizeRequest());

    dispatch({
      type: FILE_SAVED,
      payload: { message: 'File Saved!' }
    });
  } catch (error) {
    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: 'File not Saved!', open: true }
    });
    console.error('error writing to json file', error);
  }
};



// WEBPACK FOOTER //
// ./src/actions/saveToJSONFile.js